// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__gMClw","errorLogs":"styles_errorLogs__F-Xfc"};